<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <skeletal-loader type="table">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="filteredData"
        show-select
        class="elevation-1"
        hide-default-footer>
        <template v-slot:item.name="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-edit-dialog
                :return-value.sync="item.name"
                cancel-text="İptal"
                save-text="Kaydet"
                large
                @save="editGroup(item.id, item.name)">
                <span v-on="on">{{ item.name }}</span>
                <template v-slot:input>
                  <v-text-field
                    v-model="item.name"
                    label="Düzenle"
                    single-line
                    counter>
                  </v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <span>Grup Adını Güncelle</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                medium
                @click="deleteGroup(item.id)">
                delete
              </v-icon>
            </template>
            <span>Grubu Sil</span>
          </v-tooltip>
        </template>
        <template v-if="data.length > 0" v-slot:footer>
          <td class="text-xs-left">
            <v-icon
              medium
              @click.stop="deleteBulk">
              delete
            </v-icon>
            Seçili Tüm Grupları Sil
          </td>
        </template>
      </v-data-table>
    </skeletal-loader>
    <skeletal-loader type="list">
      <pagination :pagination="pagination" :action="noSyncLoad"></pagination>
    </skeletal-loader>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import SkeletalLoader from '../../SkeletalLoader.vue';
import Pagination from '../Pagination.vue';

export default {
  components: { Pagination, SkeletalLoader },
  props: ['search'],
  data: () => ({
    headers: [
      { text: 'Ad', value: 'name' },
      { text: 'Kayıt', value: 'contacts_count' },
      {
        text: 'İşlemler',
        value: 'actions',
        searchable: false,
      },
    ],
    pagination: {
      current: 1,
      total: 0,
    },
    data: [],
    selected: [],
    searchKeyword: '',
  }),
  created() {
    this.noSyncLoad();
  },
  watch: {
    search(nv) {
      this.searchKeyword = nv;
    },
  },
  methods: {
    ...mapActions({
      send: 'sendBackend',
      sendAsync: 'asyncSender',
    }),
    noSyncLoad() {
      this.send({ route: `show/groups?page=${this.pagination.current}` })
        .then((res) => {
          this.data = res.data.data.data;
          this.pagination.current = res.data.data.current_page;
          this.pagination.total = res.data.data.last_page;
        });
    },
    async asyncOnLoad() {
      this.sendAsync({ route: `show/groups?page=${this.pagination.current}` })
        .then((res) => {
          this.data = res.data.data.data;
          this.pagination.current = res.data.data.current_page;
          this.pagination.total = res.data.data.last_page;
        });
    },
    async deleteGroup(id) {
      this.$store.commit('fireConfirmation', () => {
        const route = 'delete/groups';
        const data = { id: Array.isArray(id) ? id : [id] };

        this.send({ route, data })
          .then(async () => {
            this.asyncOnLoad();
          });
      });
    },
    async deleteBulk() {
      if (this.selected.length > 0) {
        // Seçili olanlar obje olarak kaydedildiği için,
        // bu aşamada yanlızca id'lerini alıyorum.
        this.selected = this.selected.map(a => a.id);

        this.deleteGroup(this.selected);
      }
    },
    editGroup(id, name) {
      const route = 'update/group';
      const data = { id, name };

      this.send({ route, data });
    },
  },
  computed: {
    filteredData() {
      return this.data.filter(
        item => item.name.toLowerCase()
          .includes(this.searchKeyword.toLowerCase()),
      );
    },
  },
  events: {
    'onload:load': 'asyncOnLoad',
  },
};
</script>
